const API_URL = process.env.REACT_APP_API_URL;

let logoutCallback: (() => void) | null = null;

export const setLogoutCallback = (callback: () => void) => {
  logoutCallback = callback;
};

export interface ApiOptions extends RequestInit {
  skipAuth?: boolean;
}

export const apiFetch = async (
  endpoint: string,
  options: ApiOptions = {},
): Promise<Response> => {
  const { skipAuth = false, headers = {}, ...fetchOptions } = options;

  const defaultHeaders: HeadersInit = {
    "Content-Type": "application/json",
    ...headers,
  };

  // Add auth token if not skipping auth
  if (!skipAuth) {
    const token = localStorage.getItem("token");
    if (token) {
      (defaultHeaders as Record<string, string>)["Authorization"] =
        `Bearer ${token}`;
    }
  }

  try {
    const response = await fetch(`${API_URL}${endpoint}`, {
      ...fetchOptions,
      headers: defaultHeaders,
    });

    // Handle authentication errors
    if (response.status === 401 || response.status === 403) {
      // Clear local storage
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      // Call logout callback if available
      if (logoutCallback) {
        logoutCallback();
      }

      // Redirect to login
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }

      // Throw error to prevent further processing
      throw new Error("Session expired. Please log in again.");
    }

    return response;
  } catch (error: any) {
    // Re-throw authentication errors
    if (error.message === "Session expired. Please log in again.") {
      throw error;
    }

    // Handle network errors
    if (
      error.name === "TypeError" ||
      error.message === "Something went wrong"
    ) {
      throw new Error(
        `Kindly try again later. If the issue persists, please contact support.`,
      );
    }
    throw error;
  }
};
